export default function Graphics_Home() {
  return (
    <div>
      <h1>Graphics_Home Component</h1>
    </div>
  );
}
